import { render, staticRenderFns } from "./CarDetail.vue?vue&type=template&id=1678296e&"
import script from "./CarDetail.vue?vue&type=script&lang=ts&"
export * from "./CarDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CarDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports